import { useEffect, useState } from 'react'

import { invoiceAPI } from '../api/services/invoice'
import { InvoicesTypes } from '../api/services/invoice/types.ts'

export const useInvoices = () => {
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string | null>(null)
  const [invoices, setInvoices] = useState<InvoicesTypes[] | null>(null)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await invoiceAPI.getInvoices()

        if (response.error) {
          setError(response.error)
          setLoading(false)
          return
        }

        const data = response.data

        if (data) {
          setInvoices(data)
        }
      } catch {
        setError('Something went wrong while fetching pricing data.')
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [])

  return { invoices, loading, error }
}
